import { LoadingDots } from "../common";
import { Box, Fade } from "@mui/material";

interface LoadingPageProps {
  theme?: "light" | "dark";
}

export const LoadingPage = ({ theme = "dark" }: LoadingPageProps) => {
  return (
    <Fade in>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <LoadingDots theme={theme} />
      </Box>
    </Fade>
  );
};
